import { useNavigateWithSearch } from 'infrastructure/routing'
import { useSearchParams } from 'shared/hooks'
import { useCallback } from 'react'

export function useClearTreeMgmtTree() {
  const navigate = useNavigateWithSearch()
  const [searchParams] = useSearchParams()

  return useCallback(() => {
    const params = new URLSearchParams({
      tMgmt: searchParams.get('tMgmt') ?? '',
    })
    navigate({ pathname: '/tree_management', search: params.toString() })
  }, [searchParams, navigate])
}
